import { useEffect } from 'react'

import { StorageLegacyIds } from '@/constants/storage'

export const useClearLegacyKeysFromLS = () => {
  useEffect(() => {
    StorageLegacyIds.forEach((id) => {
      localStorage.removeItem(id)
    })
  }, [])
}
